module.exports = __webpack_public_path__ + "img/external-link-alt-solid.03979156.svg";